import { ModuleWithProviders } from '@angular/core';
import { AuthConfig, OAuthModuleConfig, OAuthStorage, } from 'angular-oauth2-oidc';
import { authProdConfig } from './auth/auth-config.prod';
import { authModuleConfig } from './auth/auth-module-config';
import { throwIfAlreadyLoaded } from './module-import-guard';
export function storageFactory() {
    return localStorage;
}
var CoreModule = /** @class */ (function () {
    function CoreModule(parentModule) {
        throwIfAlreadyLoaded(parentModule, "CoreModule");
    }
    CoreModule.forRoot = function () {
        return {
            ngModule: CoreModule,
            providers: [
                { provide: AuthConfig, useValue: authProdConfig },
                { provide: OAuthModuleConfig, useValue: authModuleConfig },
                { provide: OAuthStorage, useFactory: storageFactory },
            ]
        };
    };
    return CoreModule;
}());
export { CoreModule };
